import { Injectable } from '@angular/core';
import moment from 'moment';
import { TimeDateValidator } from './time-date-validator.service';

@Injectable({
  providedIn: 'root'
})

export class DateValidator extends TimeDateValidator {

  getTimeDateStamp(formData) {
    const dateFormat = 'MM/DD/YYYY';
    const minValue = moment('01/01/2020', dateFormat);
    const maxValue = moment('12/31/2020', dateFormat);

    const dateStamp = moment(formData, dateFormat);

    return dateStamp.isBetween(minValue, maxValue);
  }

  // validateTimeDate() is invoked from base class
}
